import { useLocation, useNavigate } from 'react-router-dom';
import { Stack } from '@/Components/ui/layout';
import { Tabs, TabsList, TabsTrigger } from '@/Components/ui/tabs';
import { cn } from '@/lib/utils';

export const CategoryTabs = ({ activeTab, onTabClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const currentTab = state?.activeTab || activeTab || 'Open Tech Jobs';
  
  const tabRoutes = {
    "Open Tech Jobs": "/OpenTechJobs",
    "Big Tech Hiring": "/BigTechHiring",
    "Top Tech Company": "/TopTechCompany",
    "Hottest Companies by Sector": "/HottestCompaniesBySector",
    "Top Tech Location": "/TopTechLocation",
    "Hottest Companies by Investor": "/HottestCompaniesByInvestor",
    "Tech Industry Stats": "/TechIndustryStats",
    "Remote Index": "/RemoteIndex"
  };
  
  const allTabs = [
    'Open Tech Jobs',
    'Big Tech Hiring',
    'Top Tech Company',
    'Top Tech Location',
    'Hottest Companies by Sector',
    'Hottest Companies by Investor',
    'Tech Industry Stats',
    'Remote Index',
  ];

  const handleTabChange = (value) => {
    const route = tabRoutes[value];
    if (route) {
      navigate(route, {
        state: { 
          activeTab: value,
          selectedTrend: value
        }
      });
    }
    if (onTabClick) {
      onTabClick(value);
    }
  };

  return (
    <div className="py-8 mt-10 items-center ml-[70px]">
      <Tabs value={currentTab} onValueChange={handleTabChange} className="w-full">
        <TabsList className={cn(
          "inline-flex h-auto items-center justify-center rounded-xl bg-transparent p-1 text-muted-foreground",
          "flex-wrap gap-4 w-full max-w-5xl"
        )}>
          {allTabs.map(tab => (
            <TabsTrigger
              key={tab}
              value={tab}
              className={cn(
                "px-6 py-3 rounded-xl text-base font-medium transition-all backdrop-blur-md",
                "border border-white/10 bg-white/2 hover:-translate-y-0.5",
                "data-[state=active]:bg-gradient-to-r data-[state=active]:from-primary data-[state=active]:via-[#50c598] data-[state=active]:to-primary",
                "data-[state=active]:border-none data-[state=active]:shadow-lg data-[state=active]:shadow-primary/30",
                "data-[state=active]:text-white"
              )}
            >
              {tab}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
};
